import Header from 'depreciations/components/list/DepreciationsListHeader';
import Filters from 'depreciations/components/list/DepreciationsListFilters';
import Table from 'depreciations/components/list/DepreciationsListTable';
import Row from 'depreciations/components/list/DepreciationsListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/index.js